import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import api from '../utils/api';

/**
 * Centralized favorites state · used by both the topbar Apps mega-menu
 * (where users pin/unpin) and the splash sidebar (where the pinned apps
 * render as quick-launch chips). Without a context, both would fetch and
 * mutate independently and drift apart on click.
 */

const Ctx = createContext({
  favorites: [],
  saving: false,
  toggle: () => {},
});

// eslint-disable-next-line react-refresh/only-export-components
export const useFavorites = () => useContext(Ctx);

export default function FavoritesProvider({ children }) {
  const [favorites, setFavorites] = useState([]);
  const [saving, setSaving]       = useState(false);

  useEffect(() => {
    api.myEmployee()
      .then(emp => setFavorites(Array.isArray(emp?.favorite_apps) ? emp.favorite_apps : []))
      .catch(() => setFavorites([]));
  }, []);

  const toggle = useCallback((slug) => {
    setFavorites(prev => {
      const next = prev.includes(slug) ? prev.filter(s => s !== slug) : [...prev, slug];
      setSaving(true);
      api.updateMyFavorites(next)
        .catch(() => {/* optimistic · ignore network blips */})
        .finally(() => setSaving(false));
      return next;
    });
  }, []);

  const value = useMemo(() => ({ favorites, saving, toggle }), [favorites, saving, toggle]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}
